export default __webpack_public_path__ + "static/media/pictogramBeaconEarthHeart40.9dfdaca1.svg";